import React, { useEffect, useState, useRef } from "react";
import ReactPaginate from "react-paginate";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import moment from "moment";
import "./style.scss";
import { useStores } from "../../stores";
import notify from "../../shared/notify";
import deletebtn from "../../assets/images/trash (1).png";
import editbtn from "../../assets/images/edit (3).png";
import EditModal from "../../components/Modal/CashVoucherEditModal";
import ConfirmationModal from "../../components/Modal/CashVoucherConfirmationModal";
import calendar from "../../assets/images/calendar.png";
import Loader from "../../helper/Loader/Loader";
import ReactExport from "react-export-excel";
import downloadPdfImage from "../../assets/images/download.png";
import DownloadPdfModal from "../../components/Modal/DownloadPdfModal";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const limit = [
  {
    option: 2,
    value: 2,
  },
  {
    option: 10,
    value: 10,
  },
  {
    option: 100,
    value: 100,
  },
  {
    option: 500,
    value: 500,
  },
  {
    option: 1000,
    value: 1000,
  },
];

const CashVoucher = () => {
  const startCalendarRef = useRef();
  const endCalendarRef = useRef();
  const { authStore } = useStores();
  const userId = sessionStorage.getItem("id");
  const [isLoading, setIsLoading] = useState(false);
  const [partyies, setPartyies] = useState([]);
  const [selectedParty, setSelectedParty] = useState("");
  const [selectExpenditure, setSelectExpenditure] = useState("")
  const [expenditure, setExpenditure] = useState([]);
  const [addedExpenditure, setAddedExpenditure] = useState("")
  const [particular, setParticular] = useState("");
  const [amount, setAmount] = useState();
  const createdd = sessionStorage.getItem("id");
  const date = sessionStorage.getItem("date");
  let currentDate = sessionStorage.getItem("date");
  if (currentDate) {
    currentDate = moment(currentDate, "DD-MM-YYYY").format("YYYY-MM-DD");
  }
  const [addedName, setAddedName] = useState("");
  const [show, setShow] = useState(true);
  const [showExpenditure, setShowExpenditure] = useState(true);
  const [fetchedData, setFetchedData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalPdf, setShowModalPdf] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [selectedVoucher, setSelectedVoucher] = useState();
  const [voucherNum, setVoucherNum] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [filterVoucherNumber, setFilterVoucherNumber] = useState("");
  const [filterparty, setFilterParty] = useState("");
  const [filteramount, setFilterAmount] = useState("");
  const [pageLimit, setPageLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [cashVoucherData, setCashVoucherData] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const role = sessionStorage.getItem("role");
  const [selectedRow, setSelectedRow] = useState();
  const [voucherDate, setVoucherDate] = useState(currentDate);

  useEffect(() => {
    setIsAdmin(role === "Admin");
    handleparty();
    fetchData();
    handleExpenditure()
  }, []);

  const handleparty = async () => {
    setIsLoading(true);
    await authStore.partiesList(
      (response) => {
        if (response?.meta?.status === "success") {
          let data = [...response?.data?.parties];
          let obj = {
            id: "0",
            name: "Other",
          };
          data.push(obj);
          const selectOptions = data.map((option) => ({
            value: option.id,
            label: option.name,
          }));
          setPartyies(selectOptions);
          setIsLoading(false);
        } else {
          notify(response?.meta?.message, "danger");
          setIsLoading(false);
        }
      },
      (error) => {
        notify(error?.response?.meta?.message, "danger");
        setIsLoading(false);
      }
    );
  };

  const fetchData = async () => {
    let payload = {
      limit: pageLimit,
      filters: {},
      pageNumber: page,
    };
    callApi(payload);
  };

  const handleCreateCashVoucher = async () => {
    setIsLoading(true);
    let payload = {
      partyId: selectedParty?.value,
      particulars: particular,
      amount: amount,
      createdBy: createdd,
      expenditureHead: selectExpenditure?.value
    };

    if (role === "Admin") {
      // payload.voucherDate = moment(new Date(voucherDate)).format("YYYY-MM-DD");
      payload.voucherDate = voucherDate;
    }
    await authStore.createCashVoucher(
      payload,
      (response) => {
        if (response?.data?.meta?.status === "success") {
          notify(response?.data?.meta?.message, "success");
          setIsLoading(false);
          fetchData();
          setSelectedParty("")
          setParticular("")
          setAmount("")
          setSelectExpenditure("")
        } else {
          notify(response?.data?.meta?.message, "danger");
          setIsLoading(false);
          setSelectedParty("")
          setParticular("")
          setAmount("")
          setSelectExpenditure("")
        }
      },
      (error) => {
        notify(error?.response?.data?.meta?.message, "danger");
        setIsLoading(false);
        setSelectedParty("")
        setParticular("")
        setAmount("")
        setSelectExpenditure("")
      }
    );
  };

  const handleAddCustomOption = async () => {
    setIsLoading(true);
    setShow(false);
    let payload = {
      name: addedName,
    };
    await authStore.addParty(
      payload,
      (response) => {
        if (response?.data?.meta?.status === "success") {
          notify(response?.data?.meta?.message, "success");
          setIsLoading(false);
          handleparty();
        } else {
          notify(response?.data?.meta?.message, "danger");
          setIsLoading(false);
        }
      },
      (error) => {
        notify(error?.response?.data?.meta?.message, "danger");
        setIsLoading(false);
      }
    );
  };

  const handlePartyNameChange = (event) => {
    const selectedValue = event;
    setSelectedParty(selectedValue);
  };
  const handleExpenditureChange = (event) => {
    const selectedValue = event;
    setSelectExpenditure(selectedValue);
  };

  const handleDeleteEntry = async (item) => {
    setShowConfirmationModal(true);
    setVoucherNum(item?.voucher_number);
  };

  const handleConfirmation = async () => {
    let payload = {
      userId: userId,
    };
    await authStore.deleteCashVoucher(
      voucherNum,
      payload,
      (response) => {
        if (response?.data?.meta?.status === "success") {
          notify(response?.data?.meta?.message);
          setShowConfirmationModal(false);
          fetchData();
        } else {
          notify(response?.data?.meta?.message, "danger");
        }
      },
      (error) => {
        notify(error?.response?.data?.meta?.message, "danger");
      }
    );
  };

  const handleEdit = (e, item) => {
    e.preventDefault();
    setSelectedVoucher(item);
    setShowModal(true);
  };

  const handleStartDate = (date) => {
    setStartDate(date);
  };

  const handleEndDate = (date) => {
    setEndDate(date);
  };

  const openDatepicker1 = () => {
    startCalendarRef.current.setFocus(true);
  };

  const openDatepicker2 = () => {
    endCalendarRef.current.setFocus(true);
  };

  const handleFilter = async () => {
    let newStartDate = startDate
      ? moment(new Date(startDate)).format("YYYY-MM-DD")
      : null;
    let newEndDate = endDate
      ? moment(new Date(endDate)).format("YYYY-MM-DD")
      : null;
    let payload = {
      limit: pageLimit,
      filters: {
        voucherNumber: filterVoucherNumber,
        voucherFromDate: newStartDate,
        voucherToDate: newEndDate,
        partyName: filterparty,
        amount: filteramount,
      },
      pageNumber: page,
    };
    callApi(payload);
  };

  const handleReset = async () => {
    setFilterAmount("");
    setFilterParty("");
    setFilterVoucherNumber("");
    setPage(1);
    setPageLimit(10);
    startCalendarRef.current.value = "";
    endCalendarRef.current.value = "";
    setStartDate(null);
    setEndDate(null);
    await fetchData();
  };

  const handlePageSubmit = async (index) => {
    setPage(index.selected + 1);
    let newStartDate = startDate
      ? moment(new Date(startDate)).format("YYYY-MM-DD")
      : null;
    let newEndDate = endDate
      ? moment(new Date(endDate)).format("YYYY-MM-DD")
      : null;
    let payload = {
      limit: pageLimit,
      filters: {
        voucherNumber: filterVoucherNumber,
        voucherFromDate: newStartDate,
        voucherToDate: newEndDate,
        partyName: filterparty,
        amount: filteramount,
      },
      pageNumber: index.selected + 1,
    };
    callApi(payload);
  };

  const limitChangeHandler = async (index) => {
    setPageLimit(index);
    let newStartDate = startDate
      ? moment(new Date(startDate)).format("YYYY-MM-DD")
      : null;
    let newEndDate = endDate
      ? moment(new Date(endDate)).format("YYYY-MM-DD")
      : null;
    let payload = {
      limit: index,
      filters: {
        voucherNumber: filterVoucherNumber,
        voucherFromDate: newStartDate,
        voucherToDate: newEndDate,
        partyName: filterparty,
        amount: filteramount,
      },
      pageNumber: page,
    };
    callApi(payload);
  };

  const callApi = async (payload) => {
    await authStore.getCashVoucher(
      payload,
      (response) => {
        if (response?.data?.meta?.status === "success") {
          setCashVoucherData(response?.data?.data);
          setFetchedData(response?.data?.data?.filteredData?.results);
          sessionStorage.setItem(
            "editCashVoucher",
            JSON.stringify(response?.data?.data?.filteredData?.results)
          );
        } else {
          notify(response?.meta?.message);
        }
      },
      (error) => {
        notify(error?.response?.meta?.message);
      }
    );
  };

  const handledownload = (item) => {
    setShowModalPdf(true);
    let { voucher_number, voucher_date, parties, particulars, amount, expenditure_heads, users } =
      item;
    setSelectedRow({
      "Voucher Number": voucher_number,
      Date:
        voucher_date &&
        new Date(voucher_date.split("T")[0]).toLocaleDateString("en-GB"),
      "Party Name": parties?.name,
      Particulars: particulars,
      Amount: amount,
      "Expenditure Head": expenditure_heads?.name,
      "Created By": users?.name,
      "Approver Signature": "",
      "Counter party Signature": "",
    });
  };

  const calculateDayDifference = (givenDate) => {
    const parsedGivenDate = new Date(givenDate);
    let currDate = new Date();
    const timeDifference = currDate - parsedGivenDate.getTime();
    const daysDifference = timeDifference / (1000 * 3600 * 24);
    return daysDifference <= 10;
  };

  const handleMenuOpen = () => {
    setSelectedParty("");
  };
  const handleMenuOpen1 = () => {
    setSelectExpenditure("");
  };

  // const getFormattedDate = (date) => {
  //   const year = date.getFullYear();
  //   const month = (date.getMonth() + 1).toString().padStart(2, "0");
  //   const day = date.getDate().toString().padStart(2, "0");
  //   return `${year}-${month}-${day}`;
  // };

  const handleExpenditure = async () => {
    setIsLoading(true);
    await authStore.expenditureList(
      (response) => {
        if (response?.meta?.status === "success") {
          let data = [...response?.data?.heads];
          let obj = {
            id: "0",
            name: "Other",
          };
          data.push(obj);
          const selectOptions = data.map((option) => ({
            value: option.id,
            label: option.name,
          }));
          setExpenditure(selectOptions);
          setIsLoading(false);
        } else {
          notify(response?.meta?.message, "danger");
          setIsLoading(false);
        }
      },
      (error) => {
        notify(error?.response?.meta?.message, "danger");
        setIsLoading(false);
      }
    );
  };
  const handleAddExpenditure = async () => {
    setIsLoading(true);
    setShowExpenditure(false);
    let payload = {
      name: addedExpenditure,
    };
    await authStore.addExpenditure(
      payload,
      (response) => {
        if (response?.data?.meta?.status === "success") {
          notify(response?.data?.meta?.message, "success");
          setIsLoading(false);
          handleExpenditure();
        } else {
          notify(response?.data?.meta?.message, "danger");
          setIsLoading(false);
        }
      },
      (error) => {
        notify(error?.response?.data?.meta?.message, "danger");
        setIsLoading(false);
      }
    );
  };

  return (
    <>
      <div className="leaddetails-container">
        <div className="RightArea">
          <div className="dashboard-area">
            <div className="container-fluid dash-container">
              <div className="needs-validation">
                <div className="row">
                  <div className="col-md-12">
                    <div className="hall-header">
                      <h2 className="sub-heading">Cash Voucher</h2>
                    </div>
                  </div>
                  <div className="receipt-form-box">
                    <div className="row">
                      <div className="col-md-3">
                        <label className="input-lable">Voucher Date</label>
                        {/* {isAdmin ? (
                          <input
                            type="text"
                            readOnly
                            className="form-control"
                            id="partyDate"
                            placeholder={date}
                            value={date}
                            // onChange={(e) => setVoucherDate(e.target.value)}
                            // max={getFormattedDate(new Date())}
                          />
                        ) : ( */}
                        <input
                          readOnly
                          type="text"
                          value={date}
                          className="form-control"
                          id="last name"
                          placeholder={date}
                          format="DD-MM-YYYY"
                        />
                        {/* )} */}
                      </div>
                      <div className="col-md-3">
                        <label className="input-lable" htmlFor="partyName">
                          Name of Party<span className="required-field">*</span>
                        </label>
                        <Select
                          value={selectedParty}
                          onChange={handlePartyNameChange}
                          options={partyies}
                          isSearchable={true}
                          placeholder="search for party"
                          onMenuOpen={handleMenuOpen}
                        />

                        {/* <SearchableInput
                            name='parties'
                            // onListItemClick={(i) => { setSelectedParty(i[0].name) }}
                            onListItemClick={(items) => { handlePartyNameChange(items[0]) }}
                            collection={partyies.map((col) => ({ ...col, id: col?.id, label: col?.name }))}
                            placeholder={selectedParty !== "" ? selectedParty : 'Select Party'}
                            theme={theme_settings}
                            showLabelText={true}
                          /> */}
                        {/* </div> */}
                        {/* <select
                          className="form-control"
                          id="partyName"
                          value={selectedParty}
                          onChange={handlePartyNameChange}
                        >
                          <option>select</option>
                          {partyies.map((party, index) => (
                            <option key={index} value={party.value}>
                              {party.name}
                            </option>
                          ))}
                          <option>Other</option>
                        </select> */}
                      </div>
                      {selectedParty?.label === "Other" && show && (
                        <div className="col-md-3">
                          <label className="input-lable">Add Name</label>
                          <div style={{ position: "relative" }}>
                            <input
                              type="text"
                              className="form-control"
                              id="customName"
                              placeholder="Type other name"
                              value={addedName?.toUpperCase()}
                              onChange={(e) => {
                                let data = e.target.value.toUpperCase();
                                setAddedName(data)
                              }}
                            />
                            <button
                              className="add-button"
                              onClick={handleAddCustomOption}
                            >
                              Add Name
                            </button>
                          </div>
                        </div>
                      )}
                      <div className="col-md-3">
                        <label className="input-lable">
                          Particulars<span className="required-field">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="Particulars"
                          placeholder="Particulars"
                          value={particular?.toUpperCase()}
                          onChange={(e) => {
                            let data = e.target.value.toUpperCase();
                            setParticular(data);
                          }}
                        />
                      </div>
                      <div className="col-md-3">
                        <label className="input-lable">
                          Amount<span className="required-field">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="Amount"
                          placeholder="Amount"
                          value={amount}
                          onChange={(e) => {
                            setAmount(e.target.value);
                          }}
                        />
                      </div>

                      <div className="col-md-3">
                        <label className="input-lable">
                          Expenditure Head<span className="required-field">*</span>
                        </label>
                        <Select
                          value={selectExpenditure}
                          onChange={handleExpenditureChange}
                          options={expenditure}
                          isSearchable={true}
                          placeholder="search for expenditure"
                          onMenuOpen={handleMenuOpen1}
                        />
                      </div>
                      {selectExpenditure?.label === "Other" && showExpenditure && (
                        <div className="col-md-3">
                          <label className="input-lable">Add Expenditure</label>
                          <div style={{ position: "relative" }}>
                            <input
                              type="text"
                              className="form-control"
                              id="customName"
                              placeholder="Type other expenditure"
                              value={addedExpenditure?.toUpperCase()}
                              onChange={(e) => {
                                let data = e.target.value.toUpperCase();
                                setAddedExpenditure(data)
                              }}
                            />
                            <button
                              className="add-button"
                              onClick={handleAddExpenditure}
                            >
                              Add Exp
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-12" style={{ textAlign: "right" }}>
                    <button
                      className=" submit-button"
                      type="submit"
                      onClick={handleCreateCashVoucher}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
              <div className="needs-validation">
                <div className="row">
                  <div className="col-md-12">
                    <div className="hall-header">
                      <h2 className="sub-heading">Entries</h2>
                    </div>
                  </div>
                  <div className="col-md-12 filter-container">
                    <div className="calendar-container">
                      <DatePicker
                        className="form-control"
                        placeholderText="From Date"
                        selected={startDate}
                        onChange={(date) => {
                          handleStartDate(date);
                        }} //only when value has changed
                        dateFormat="dd-MM-yyyy"
                        ref={startCalendarRef}
                      />
                      <div className="calendar-icon">
                        <img
                          src={calendar}
                          alt="fromcal"
                          width="20px"
                          onClick={openDatepicker1}
                        />
                      </div>
                    </div>
                    <div className="calendar-container">
                      <DatePicker
                        className="form-control"
                        placeholderText="To Date"
                        selected={endDate}
                        onChange={(date) => {
                          handleEndDate(date);
                        }} //only when value has changed
                        dateFormat="dd-MM-yyyy"
                        ref={endCalendarRef}
                      />
                      <div className="calendar-icon">
                        <img
                          src={calendar}
                          alt="tocal"
                          width="20px"
                          onClick={openDatepicker2}
                        />
                      </div>
                    </div>
                    <div>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Voucher Number"
                        value={filterVoucherNumber}
                        onChange={(e) => setFilterVoucherNumber(e.target.value)}
                      />
                    </div>
                    <div>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Party Name"
                        value={filterparty?.toUpperCase()}
                        onChange={(e) => setFilterParty(e.target.value)}
                      />
                    </div>
                    <div>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Amount"
                        value={filteramount}
                        onChange={(e) => setFilterAmount(e.target.value)}
                      />
                    </div>
                    <div className="btn-container">
                      <button
                        className="submit-button"
                        type="submit"
                        onClick={handleFilter}
                      >
                        Filter
                      </button>
                      <button
                        className="submit-button"
                        type="submit"
                        onClick={handleReset}
                      >
                        Reset
                      </button>
                      {fetchedData.length > 0 && (
                        <button className="submit-button">
                          <ExcelFile element={<span style={{ cursor: "pointer" }}  > Export  </span>} >
                            <ExcelSheet
                              data={fetchedData.map((item, i) => ({
                                ...item,
                                index: i + 1,
                                voucher_date: new Date(
                                  item.voucher_date
                                ).toLocaleDateString("en-GB", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "2-digit",
                                }),
                              }))}
                              name="Sheet"
                            >
                              <ExcelColumn label="Sr.No" value="index" />
                              <ExcelColumn
                                label="Voucher No."
                                value="voucher_number"
                              />
                              <ExcelColumn
                                label="Voucher Date"
                                value="voucher_date"
                              />
                              <ExcelColumn
                                label="Name of Party"
                                value={(item) => item?.parties?.name?.toUpperCase()}
                              />
                              <ExcelColumn
                                label="Particulars"
                                value={(item) => item?.particulars?.toUpperCase()}
                              />
                              <ExcelColumn label="Amount" value="amount" />
                              <ExcelColumn label="Expenditure Head" value={(item) => item?.expenditure_heads?.name?.toUpperCase()} />
                            </ExcelSheet>
                          </ExcelFile>
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div>
                      <label className="d-flex align-items-center p-0 col-md-2">
                        {page === 1 ? (
                          <select
                            value={pageLimit}
                            className="form-control selectbox-container mr-2"
                            onChange={(e) => limitChangeHandler(e.target.value)}
                          >
                            {limit.length > 0
                              ? limit.map((item, index) => (
                                <option key={index} value={item.option}>
                                  {item.value}
                                </option>
                              ))
                              : null}
                          </select>
                        ) : (
                          <p className="form-control selectbox-container mx-2 my-0">
                            {pageLimit}
                          </p>
                        )}
                        <span> entries</span>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-12 listing-table">
                    <div className="data-table  py-4  table-responsive">
                      <table
                        className="details-box table-bordered "
                        id="table-to-xls"
                      >
                        <thead className="thead-box">
                          <tr className="thead">
                            <th className="action">Sr.No</th>
                            <th className="action">Voucher No.</th>
                            <th className="action">Voucher Date</th>
                            <th className="name">Name of Party</th>
                            <th className="name">Particulars</th>
                            <th className="name">Amount</th>
                            <th className="name">Expenditure Head</th>
                            <th className="action">Action</th>
                          </tr>
                        </thead>
                        {fetchedData.length > 0 ? (
                          <tbody>
                            {fetchedData.map((item, i) => {
                              return (
                                <>
                                  <tr key={item.voucher_number}>
                                    <td className="table-td">{i + 1}</td>
                                    <td className="table-td">
                                      {item.voucher_number}
                                    </td>
                                    <td className="table-td">
                                      {/* {item.voucher_date?.split("T")[0]} */}
                                      {item.voucher_date &&
                                        new Date(
                                          item.voucher_date
                                        ).toLocaleDateString("en-GB")}
                                    </td>
                                    <td className="table-td">
                                      {item?.parties?.name}
                                    </td>
                                    <td className="table-td">
                                      {item.particulars}
                                    </td>
                                    <td className="table-td">{item.amount}</td>
                                    <td className="table-td">{item?.expenditure_heads?.name}</td>
                                    <td
                                      className="table-td"
                                      style={{ textAlign: "center" }}
                                    >
                                      <button className="disablebtn">
                                        {isAdmin && (
                                          <div className="action-btn">
                                            <img
                                              className="deletebutton"
                                              src={deletebtn}
                                              alt="..."
                                              onClick={(e) =>
                                                handleDeleteEntry(item)
                                              }
                                            />
                                          </div>
                                        )}
                                        {/* {role !== "View" &&calculateDayDifference(item.voucher_date) &&
                                        (
                                          <div className="action-btn">
                                            <img
                                              className="deletebutton"
                                              src={editbtn}
                                              alt="..."
                                              onClick={(e) =>
                                                handleEdit(e, item)
                                              }
                                            />{" "}
                                          </div>
                                        )} */}
                                        {role !== "View" && (
                                          <div className="action-btn">
                                            {role === "Admin" && (
                                              <img
                                                className="deletebutton"
                                                src={editbtn}
                                                alt="..."
                                                onClick={(e) =>
                                                  handleEdit(e, item)
                                                }
                                              />
                                            )}
                                            {role === "Operator" &&
                                              calculateDayDifference(
                                                item.voucher_date
                                              ) && (
                                                <img
                                                  className="deletebutton"
                                                  src={editbtn}
                                                  alt="..."
                                                  onClick={(e) =>
                                                    handleEdit(e, item)
                                                  }
                                                />
                                              )}
                                          </div>
                                        )}
                                        <div className="action-btn">
                                          <img
                                            className="deletebutton"
                                            src={downloadPdfImage}
                                            alt="..."
                                            onClick={(e) =>
                                              handledownload(item)
                                            }
                                          />
                                        </div>
                                      </button>
                                    </td>
                                  </tr>
                                </>
                              );
                            })}
                          </tbody>
                        ) : (
                          <tbody>
                            <tr>
                              <td className="text-center p-3" colSpan={8}>
                                No Records found...
                              </td>
                            </tr>
                          </tbody>
                        )}
                      </table>
                    </div>
                    {/* {selectedRow && <DownloadPdf data={selectedRow} />} */}
                  </div>
                  <div className="col-md-12">
                    <div className="d-flex align-items-center justify-content-between my-4">
                      <div>
                        <p>
                          showing {cashVoucherData.filteredCount} out of{" "}
                          {cashVoucherData.totalRecords}
                        </p>
                      </div>
                      <div>
                        <ReactPaginate
                          previousLabel={"Previous"}
                          nextLabel={"Next"}
                          breakLabel={"..."}
                          pageCount={cashVoucherData.totalPages}
                          marginPagesDisplayed={3}
                          pageRangeDisplayed={3}
                          onPageChange={handlePageSubmit}
                          containerClassName={
                            "pagination justify-content-center"
                          }
                          pageClassName={"page-item"}
                          pageLinkClassName={"page-link"}
                          previousClassName={"page-item"}
                          previousLinkClassName={"page-link"}
                          nextClassName={"page-item"}
                          nextLinkClassName={"page-link"}
                          breakClassName={"page-item"}
                          breakLinkClassName={"page-link"}
                          activeClassName={"active"}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <EditModal
        show={showModal}
        hide={() => {
          setShowModal(false);
        }}
        key={selectedVoucher?.voucher_number}
        data={selectedVoucher}
        onSubmit={fetchData}
        partyies={partyies}
        expenditure={expenditure}
      />
      <ConfirmationModal
        show={showConfirmationModal}
        hide={() => {
          setShowConfirmationModal(false);
        }}
        handleDeleteConfirmation={() => {
          handleConfirmation();
        }}
      />
      <DownloadPdfModal
        show={showModalPdf}
        hide={() => {
          setShowModalPdf(false);
        }}
        data={selectedRow}
      />
      {isLoading && <Loader />}
    </>
  );
};

export default CashVoucher;
